import { faSearch, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Input } from "@mui/joy";

interface EntitiesSearchProps {
  placeholder: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  testId?: string;
  onClear: () => void;
}

const EntitiesSearch: React.FC<EntitiesSearchProps> = ({
  placeholder,
  onChange,
  value,
  onClear,
  testId,
}) => {
  return (
    <Input
      data-testid={testId}
      endDecorator={
        value ? (
          <IconButton onClick={onClear}>
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        ) : null
      }
      onChange={onChange}
      placeholder={placeholder}
      startDecorator={<FontAwesomeIcon icon={faSearch} />}
      sx={{ width: "100%" }}
      value={value}
    />
  );
};

export default EntitiesSearch;
